export default "__VITE_ASSET__DEep7Eo0__"